/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Добавить роль участников мероприятия.
 */
export interface ParticipantRolesForUnionAdd { 
    /**
     * Название роли.
     */
    name: string;
    /**
     * ID ассоциации.
     */
    parentOrganisationId?: string;
    /**
     * Сортировка.
     */
    sortOrder?: number;
}

